import styled, { css } from 'styled-components'
import { WarningAmber } from '@styled-icons/material-outlined'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
`

export const Mensagem = styled.div`
  width: 510px;
  height: 137px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.lightRed};
  `}
`

export const Icone = styled(WarningAmber)`
  width: 38px;
  margin-right: 32px;
`

export const Texto = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    color: ${theme.colors.black};
    font-size: ${theme.font.sizes.small};
  `}
  white-space: pre-line;
  text-align: center;
  line-height: 22px;
`
